// extracted by mini-css-extract-plugin
export default {"avatar":"Account_avatar__IS4yq","divider":"Account_divider__pqsws","item":"Account_item__Y+OYr"};